const getHeadersFromRawData = (inputArray) =>
  inputArray.map((column) => ({
    column
  }));

const getHeadersFromRankedRawData = (inputData) => {
  let columns;

  if (Array.isArray(inputData.columns)) {
    columns = inputData.columns;
  } else if (typeof inputData.columns === 'object') {
    columns = Object.values(inputData.columns);
  } else {
    return null;
  }

  if (!columns || columns.length === 0) {
    return null;
  }

  return columns.map((column) => ({
    column
  }));
};

export { getHeadersFromRawData, getHeadersFromRankedRawData };
